import styled from 'styled-components';

export const PlayWrapper = styled.div`
  font-family: var(--gameday-primary-font);
  >div {
    margin-bottom: 32px;
  }
`;
